<template>
  <QPageContainer>
    <QPage class="row q-pt-xl justify-center">
      <SAISpinner size="xl" />
    </QPage>
  </QPageContainer>
</template>

<script>
import { QPageContainer, QPage } from 'quasar';

export default {
  name: 'SAIPageSpinner',
  components: {
    QPageContainer,
    QPage,
    SAISpinner: () => import('../../atom/sai-spinner')
  }
};
</script>
